/* eslint-disable no-use-before-define */
/* eslint-disable import/order */
/*
 * @Author: gvillena
 * @Date: 2020-06-26 02:32:28
 * @Last Modified by: gvillena
 * @Last Modified time: 2020-06-26 03:18:56
 */
/* eslint-disable spaced-comment */

import {
  Button,
  Col,
  Icons,
  Layout as LayoutBase,
  Modal,
  Row,
  Spin,
  Table,
  notification,
  colors,
} from 'fractalia-design';
import React, { useEffect, useState } from 'react';
import PlantillaLegacy from '../files/LEGACY_LEG-G4SPREM_01.xlsx';
import Actions from '../../shared/components/Actions';
import UsersLoader from '../../shared/components/UsersLoader';
import columns from '../columns';
import styled from '@emotion/styled';
import { useIdentity } from 'fractalia-provisioner/identity';
import useLegacy from '../hooks/useLegacy';
import useRowValidator from '../../shared/hooks/useRowValidator';
import useProjectCodeValidator from '../../shared/hooks/useProjectCodeValidator';
import { useApp } from '../../../app/hooks/useApp';
import UsersTable from '../../shared/components/UsersTable';
import GettingStarted from '../../shared/components/GettingStarted';
import ProjectCodeSelector from '../../shared/components/ProjectCodeSelector';

const Layout = styled(LayoutBase)`
  background-color: #fff;
  width: 100%;
`;

const { Header: HeaderBase, Content: ContentBase } = LayoutBase;

const Content = styled(ContentBase)`
  display: flex;
  justify-content: center;
`;

//========================================================================================
/*                                                                                      *
 *                                        Header                                        *
 *                                                                                      */
//========================================================================================

const Header = styled(HeaderBase)`
  background-color: #fff;
  color: #1890ff;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-directions column;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 500
  `;

//========================================================================================
/*                                                                                      *
 *                              LegacyProvisionerPage                                   *
 *                                                                                      */
//========================================================================================

function LegacyProvisionerPage() {
  const gettingStartedProps = {
    onStartClick: onStartClick,
    title: 'Provisionador Legacy',
    text:
      'Bienvenido usuario, con la ayuda de esta herramienta usted podra provisionar usuarios en la plataforma Legacy',
    templateFile: PlantillaLegacy,
  };

  //* ────────────────────────────────────────────────────────────────────────────────────────
  //* ──── state ─────────────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────────────

  const [users, setUsers] = useState({ data: [], file: null, headers: [] });
  const [tableColumns, setTableColumns] = useState([]);
  const [invalidRowsFounded, setInvalidRowsFounded] = useState([]);
  const [starterVisible, setStarterVisible] = useState(false);
  const [restVisible, setRestVisible] = useState(false);
  const [projectCode, setProjectCode] = useState();

  //* ────────────────────────────────────────────────────────────────────────────────
  //* ──── hooks ─────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────

  const app = useApp();

  const identity = useIdentity();
  const { user } = identity;

  const { checkInvalidRows, reduceInvalidRows } = useRowValidator(columns);

  const {
    legacyProvisioningSubmit: submit,
    legacyProvisioningSubmitRequested: submitRequested,
    legacyProvisioningSubmitSucceeded: submitSucceeded,
    legacyProvisioningSubmitFailed: submitFailed,
  } = useLegacy();

  const {
    projectCodeList,
    projectCodeGetAllSubmit,
    projectCodeGetAllSubmitRequested,
    projectCodeGetAllSubmitSucceeded,
    projectCodeGetAllSubmitFailed,
  } = useProjectCodeValidator();

  //* ────────────────────────────────────────────────────────────────────────────────────────
  //* ──── effects ───────────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const { onSetCurrentMenu } = app;
    onSetCurrentMenu('legacy');
    setStarterVisible(true);
  }, []);

  useEffect(() => {
    if (!users.file) {
      return;
    }
    const tblCol = [];
    columns.forEach((column, index) => {
      if (column.isRequired || users.data.some((row) => !!row[column.key])) {
        tblCol.push({
          title: column.header,
          key: column.key,
          dataIndex: column.key,
          width: column.width ? column.width : null,
          ellipsis: true,
        });
      }
    });
    setTableColumns(tblCol);
  }, [users]);

  useEffect(() => {
    if (submitSucceeded) {
      onReset();
      Modal.success({
        title: 'Success',
      });
    }
    if (submitFailed) {
      Modal.error({
        title: 'Error',
      });
    }
  }, [submitSucceeded, submitFailed]);

  useEffect(() => {
    if (invalidRowsFounded.length > 0) {
      const reduced = reduceInvalidRows(invalidRowsFounded);
      Object.entries(reduced).forEach(([key, value]) => {
        notification.error({
          message: `Error en la ${key}`,
          description: `No se encontraron datos en la(s) column(as) ${value.reduce(
            (acc, err, index) => {
              return (
                acc + err.header + (index === value.length - 1 ? '' : ', ')
              );
            },
            ''
          )}`,
          duration: 6,
        });
      });
    }

    return () => {
      if (invalidRowsFounded > 0) setInvalidRowsFounded([]);
    };
  }, [invalidRowsFounded]);

  //* ────────────────────────────────────────────────────────────────────────────────
  //* ──── variables ─────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────
  const { logout } = identity;

  //* ────────────────────────────────────────────────────────────────────────────────
  //* ──── functions ─────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────

  function onSubmit() {
    const invalidRows = checkInvalidRows(users.data);
    if (invalidRows && invalidRows.length > 0) {
      const reduced = reduceInvalidRows(invalidRows);
      Object.entries(reduced).forEach(([key, value]) => {
        notification.error({
          message: `Error en la ${key}`,
          description: `No se encontraron datos en la(s) column(as) ${value.reduce(
            (acc, err, index) => {
              return (
                acc + err.header + (index === value.length - 1 ? '' : ', ')
              );
            },
            ''
          )}`,
          duration: 6,
        });
      });
      return;
    }
    let actionInvalid = false;
    users.data.forEach((row, index) => {
      if (Object.prototype.hasOwnProperty.call(row, 'action')) {
        const validActions = ['new', 'resume', 'pause', 'del'];
        const rowAction = row.action.replace(/\s+/g, '').toLowerCase();
        if (!validActions.includes(rowAction)) {
          notification.error({
            message: `Action invalido en la fila ${index + 1}`,
            description: 'NEW - RESUME - PAUSE - DEL',
            duration: 6,
          });
          actionInvalid = true;
        }
      }
    });

    if (actionInvalid) {
      return;
    }

    // let projectCodeInvalid = false;
    // users.data.forEach((row) => {
    //   const list = projectCodeList.map((pc) => pc.code);
    //   console.log(list);
    //   if (!list.includes(row.projectCode)) {
    //     notification.error({
    //       message: `Project Code invalido encontrado`,
    //       duration: 6,
    //     });
    //     projectCodeInvalid = true;
    //   }
    // });
    // if (projectCodeInvalid) {
    //   return;
    // }

    if (!projectCode) {
      notification.error({
        message: 'Debe seleccionar la plataforma a provisionar',
        duration: 4,
      });
      return;
    }
    const { projects, userId } = user;
    const projectCodeId = projects.find((p) => p.name === projectCode).code;
    const data = users.data.map((u) => {
      return { ...u, userId, projectCode: projectCodeId };
    });
    submit(data, users.file);
  }

  function onReset() {
    setUsers({ data: [], file: null, headers: [] });
    setTableColumns([]);
  }

  function onStartClick() {
    setStarterVisible(false);
    setRestVisible(true);
  }

  function onShowInfo() {
    setStarterVisible(true);
    setRestVisible(false);
  }

  function getProjectsOptions() {
    const { projects } = user;
    const list = projects.map((p) => {
      return { value: p.name, label: p.description };
    });

    return list.filter((e) => e.value.startsWith('LEG'));
  }

  //* ────────────────────────────────────────────────────────────────────────────────────────
  //* ──── component ─────────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────────────

  return (
    <Layout>
      {starterVisible && <GettingStarted {...gettingStartedProps} />}
      {restVisible && (
        <Spin spinning={submitRequested}>
          <Content>
            {!users.file && (
              <UsersLoader
                onLoad={(e) => {
                  setUsers({
                    data: e.data,
                    file: e.file,
                    headers: e.headers,
                  });
                }}
                columns={columns}
              />
            )}
            {users.file && (
              <div>
                <UsersTable
                  columns={tableColumns}
                  dataSource={users.data}
                  size="small"
                  tableLayout="fixed"
                  scroll={{ x: 1300 }}
                />
                <div css={{ display: 'flex', justifyContent: 'space-between' }}>
                  <ProjectCodeSelector
                    options={getProjectsOptions()}
                    onChange={(code) => setProjectCode(code)}
                    value={projectCode}
                  />
                  <Actions
                    onSubmit={onSubmit}
                    onReset={onReset}
                    onShowInfo={onShowInfo}
                  />
                </div>
              </div>
            )}
          </Content>
        </Spin>
      )}
    </Layout>
  );
}

export default LegacyProvisionerPage;
